import React from 'react';
import { ListActiveAndCompletedInvoiceContext } from 'src/context';
import MobileListInvoices from 'src/components/MobileListInvoices';
import Decorator from 'src/components/Decorator';
import NoData from 'src/components/NoData';

const MobileGetPaid = () => {
  return (
    <div className="gray-background">
      <ListActiveAndCompletedInvoiceContext.Consumer>
        {
          (invoices: any) => {
            if (!invoices.length) {
              return <NoData className="full-height" />
            }

            return (
              <>
                <Decorator />
                <MobileListInvoices invoices={invoices} />
              </>
            )
          }
        }
      </ListActiveAndCompletedInvoiceContext.Consumer>
    </div>
  )
}

export default MobileGetPaid;